import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CookieService } from 'ngx-cookie';
import { LocalStorageService } from 'angular-2-local-storage';
import { CommonService } from '..//services/common.service';
import { User } from '../models/UserObj';
import { environment } from "./../../environments/environment";
import { Observable } from 'rxjs';

@Injectable()
export class AuthguardService {

  constructor(private router: Router,
    private _localStorageService: LocalStorageService,
    private _commonService: CommonService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      //console.log('Authguard');
      var appBody = document.getElementById("appBody");
      appBody.className = ""; 
      
      let currentUser: User;
      currentUser = this._commonService.getUser();
      if (currentUser && currentUser.Status && currentUser.Token) {
          // logged in so return true
          if (state.url != '/home' && !this._localStorageService.get('HasWIPAccess')) {
              this.router.navigateByUrl('/home');
          }
          return true;
      }
      // not logged in so redirect to login page with the return url
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/authguard.service.ts